var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { PeekCurrencyInput } from "@piiqtechnologies/ui-components";
import React from "react";
export const SpaceRentPrice = (_a) => {
    var { form, field, label, enabled } = _a, props = __rest(_a, ["form", "field", "label", "enabled"]);
    const onChangeRentPrice = (rentPrice) => {
        var _a;
        //@ts-ignore
        form.setFieldValue("displayPrice", (_a = rentPrice === null || rentPrice === void 0 ? void 0 : rentPrice.target) === null || _a === void 0 ? void 0 : _a.value);
    };
    return (React.createElement(PeekCurrencyInput, Object.assign({ label: label, onChange: onChangeRentPrice, prefixSymbol: "$", field: field, form: form, disabled: !enabled }, props)));
};
export default SpaceRentPrice;
